import { render, staticRenderFns } from "./PurchasedBatteryReport.vue?vue&type=template&id=d4b31fb4&scoped=true"
import script from "./PurchasedBatteryReport.vue?vue&type=script&lang=js"
export * from "./PurchasedBatteryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b31fb4",
  null
  
)

export default component.exports